import PrivateRouteLayout from "@/components/layout/PrivateRouteLayout";

import PremiumExplore from "@/components/PremiumFeatureComponents/PremiumExplore";
import PublicRouteLayout from "@/components/layout/PublicRouteLayout";
import Admin from "@/pages/admin/Admin";
import Company from "@/pages/admin/companies/Company";
import CompanyAdmin from "@/pages/admin/companies/CompanyAdmin";
import NewCompany from "@/pages/admin/companies/NewCompany";
import RootImpactReference from "@/pages/admin/root_impact_references/RootImpactReference";
import { default as RootImpactReferences } from "@/pages/admin/root_impact_references/RootImpactReferences";
import User from "@/pages/admin/users/User";
import UserAdmin from "@/pages/admin/users/UserAdmin";
import ConsumableDetail from "@/pages/consumables/ConsumableDetail/ConsumableDetail";
import Consumables from "@/pages/consumables/ConsumableOverview/ConsumableOverview";
import CorporateDashboard from "@/pages/dashboard/CompanyDashboard/CorporateDashboard";
import CustomerDashboard from "@/pages/dashboard/CustomerDashboard/CustomerDashboard";
import DashboardLayout from "@/pages/dashboard/DashboardLayout";
import DemoDashboard from "@/pages/dashboard/DemoDashboard/DemoDashboard";
import EmployeeDashboard from "@/pages/dashboard/EmployeeDashboard/EmployeeDashboard";
import FacilityDashboard from "@/pages/dashboard/FacilityDashboard/FacilityDashboard";
import GhgDashboard from "@/pages/dashboard/GhgDashboard/GhgDashboard";
import MaterialDashboard from "@/pages/dashboard/MaterialDashboard/MaterialDashboard";
import ProductDashboard from "@/pages/dashboard/ProductDashboard/ProductDashboard";
import TransportDashboard from "@/pages/dashboard/TransportDashboard/TransportDashboard";
import BusinessTravel from "@/pages/employee/business_travel/BusinessTravel";
import EmployeeCommute from "@/pages/employee/commute/EmployeeCommute";
import TravelModes from "@/pages/employee/travel_modes/TravelModes";
import TravelModeDetail from "@/pages/employee/travel_modes/detail/TravelModeDetail";
import FacilitiesOverview from "@/pages/facilities/FacilityOverview";
import PublishedFacility from "@/pages/facilities/PublishedFacility";
import AddFacility from "@/pages/facilities/add/AddFacility";
import FacilityDetail from "@/pages/facilities/detail/FacilityDetail";
import GoodsAndServicesItemDetail from "@/pages/goods_and_services/GoodsAndServicesItemDetail/GoodsAndServicesItemDetail";
import GoodsAndServicesOverview from "@/pages/goods_and_services/GoodsAndServicesOverview/GoodsAndServicesOverview";
import AgriFootprintReferences from "@/pages/impact_references/AgriFootprintReferences";
import AllReferences from "@/pages/impact_references/AllReferences";
import CustomReferences from "@/pages/impact_references/CustomReferences";
import EcoInventReferences from "@/pages/impact_references/EcoInventReferences";
import EpdReferences from "@/pages/impact_references/EpdReferences";
import RootReferences from "@/pages/impact_references/RootReferences";
import CustomImpactReference from "@/pages/impact_references/custom/CustomImpactReference/CustomImpactReference";
import EpdDetail from "@/pages/impact_references/epd/EpdDetail";
import MaterialDetail from "@/pages/materials/MaterialDetail/MaterialDetail";
import MaterialsOverview from "@/pages/materials/MaterialOverview/MaterialsOverview";
import MatchingOverview from "@/pages/overview/MatchingOverview";
import Overview from "@/pages/overview/Overview";
import PackagingOverview from "@/pages/packaging/PackagingOverview";
import PackagingDetails from "@/pages/packaging/detail/PackagingDetails";
import PackagingBom from "@/pages/packaging/detail/bom/PackagingBom";
import PackagingRelations from "@/pages/packaging/detail/relations/PackagingRelations";
import PackagingMaterialDetail from "@/pages/packaging_materials/PackagingMaterialDetail/PackagingMaterialDetail";
import PackagingMaterialsOverview from "@/pages/packaging_materials/PackagingMaterialOverview/PackagingMaterialsOverview";
import BillOfMaterialsOverview from "@/pages/products/bom/BillOfMaterialsOverview";
import ProductDetail from "@/pages/products/detail/ProductDetail";
import BillOfMaterials from "@/pages/products/detail/bom/BillOfMaterials";
import ProductEol from "@/pages/products/detail/eol/productEol";
import ProductRelations from "@/pages/products/detail/relations/ProductRelations";
import ProductScenarios from "@/pages/products/detail/scenarios/ProductScenarios";
import ProductUsage from "@/pages/products/detail/usage/productUsage";
import EolOverview from "@/pages/products/eol/EolOverview";
import ProductsOverview from "@/pages/products/overview/ProductsOverview";
import UsageOverview from "@/pages/products/usage/usageOverview";
import PurchaseOrders from "@/pages/purchase_orders/PurchaseOrders";
import SalesOrders from "@/pages/sales_orders/SalesOrders";
import Account from "@/pages/settings/Account";
import Settings from "@/pages/settings/Settings";
import Team from "@/pages/settings/Team";
import Snapshots from "@/pages/snapshots/Snapshots";
import InboundDetail from "@/pages/transport/inbound/InboundDetail";
import InboundTransport from "@/pages/transport/inbound/InboundTransport";
import OutboundDetail from "@/pages/transport/outbound/OutboundDetail";
import OutboundTransport from "@/pages/transport/outbound/OutboundTransport";
import { createBrowserRouter, RouteObject } from "react-router-dom";
import Error from "./Error";
import NotFound from "./NotFound";
import PackagingDashboard from "@/pages/dashboard/PackagingDashboard/PackagingDashboard";

// all routes go here
const routes: RouteObject[] = [
  {
    path: "/",
    element: <PrivateRouteLayout />,
    errorElement: <NotFound />,
    children: [
      {
        index: true,
        errorElement: <Error />,
        element: <Overview />,
      },
      { path: "/facilities/", element: <FacilitiesOverview /> },
      { path: "/facilities/add", element: <AddFacility /> },
      { path: "/facilities/:facilityId", element: <FacilityDetail /> },
      { path: "/facilities/:facilityId/:mode", element: <FacilityDetail /> },
      {
        path: "/orders/purchase_orders",
        element: <PurchaseOrders />,
      },
      {
        path: "/orders/sales_orders",
        element: <SalesOrders />,
      },
      {
        path: "/consumables",
        element: <Consumables />,
      },
      {
        path: "/consumables/:consumableId",
        errorElement: <Error />,
        element: <ConsumableDetail />,
      },
      {
        path: "/goods_and_services",
        element: <GoodsAndServicesOverview />,
      },
      {
        path: "/goods_and_services/:goodsAndServicesItemId",
        errorElement: <Error />,
        element: <GoodsAndServicesItemDetail />,
      },
      {
        errorElement: <Error />,
        path: "/materials",
        element: <MaterialsOverview />,
      },
      {
        path: "/materials/:materialId",
        errorElement: <Error />,
        element: <MaterialDetail />,
      },
      {
        errorElement: <Error />,
        path: "/matching",
        element: <MatchingOverview />,
      },
      {
        errorElement: <Error />,
        path: "/matching/materials",
        element: <MaterialsOverview />,
      },
      {
        path: "/matching/materials/:materialId",
        errorElement: <Error />,
        element: <MaterialDetail />,
      },
      {
        errorElement: <Error />,
        path: "/matching/packaging/materials",
        element: <PackagingMaterialsOverview />,
      },
      {
        path: "/matching/packaging/materials/:materialId",
        errorElement: <Error />,
        element: <PackagingMaterialDetail />,
      },
      {
        path: "/packaging",
        element: <PackagingOverview />,
      },
      {
        path: "/packaging/:packagingId",
        errorElement: <Error />,
        element: <PackagingDetails />,
        children: [
          { path: "/packaging/:packagingId", element: <PackagingRelations /> },
          { path: "/packaging/:packagingId/relations", element: <PackagingRelations /> },
          { path: "/packaging/:packagingId/bom", element: <PackagingBom /> },
        ],
      },
      {
        path: "/products",
        element: <ProductsOverview />,
      },
      {
        path: "/products/bom",
        element: <BillOfMaterialsOverview />,
      },
      {
        path: "/products/:productId",
        errorElement: <Error />,
        element: <ProductDetail />,
        children: [
          {
            path: "/products/:productId",
            element: <ProductRelations />,
          },
          {
            path: "/products/:productId/bom",
            element: <BillOfMaterials />,
          },
          {
            path: "/products/:productId/relations",
            element: <ProductRelations />,
          },
          {
            path: "/products/:productId/scenarios",
            element: <ProductScenarios mode="manage" />,
          },
          {
            path: "/products/:productId/scenarios/manage",
            element: <ProductScenarios mode="manage" />,
          },
          {
            path: "/products/:productId/scenarios/compare",
            element: <ProductScenarios mode="compare" />,
          },
          {
            path: "/products/:productId/eol",
            element: <ProductEol />,
          },
          {
            path: "/products/:productId/usage",
            element: <ProductUsage />,
          },
        ],
      },
      {
        path: "admin/root_impact_references",
        errorElement: <Error />,
        element: <RootImpactReferences />,
      },
      {
        path: "admin/root_impact_references/create",
        errorElement: <Error />,
        element: <RootImpactReference />,
      },
      {
        path: "admin/root_impact_references/create/:addReferenceId",
        errorElement: <Error />,
        element: <RootImpactReference />,
      },
      {
        path: "admin/root_impact_references/:referenceId",
        errorElement: <Error />,
        element: <RootImpactReference />,
      },
      {
        path: "impact_references/custom/create",
        errorElement: <Error />,
        element: <CustomImpactReference />,
      },
      {
        path: "impact_references/custom/create/:addReferenceId",
        errorElement: <Error />,
        element: <CustomImpactReference />,
      },
      {
        path: "impact_references/custom/:referenceId",
        errorElement: <Error />,
        element: <CustomImpactReference />,
      },
      {
        path: "impact_references/epd/create",
        errorElement: <Error />,
        element: <EpdDetail />,
      },
      {
        path: "impact_references/epd/:referenceId",
        errorElement: <Error />,
        element: <EpdDetail />,
      },
      {
        path: "impact_references/epd",
        element: <EpdReferences />,
      },
      {
        path: "impact_references/custom",
        element: <CustomReferences />,
      },
      {
        path: "impact_references/eco_invent",
        element: <EcoInventReferences />,
      },
      {
        path: "impact_references/agri_footprint",
        element: <AgriFootprintReferences />,
      },
      {
        path: "impact_references/root",
        element: <RootReferences />,
      },
      {
        path: "impact_references",
        element: <AllReferences />,
      },
      {
        path: "/settings",
        errorElement: <Error />,
        element: <Settings />,
      },
      {
        path: "/account",
        errorElement: <Error />,
        element: <Account />,
      },
      {
        path: "/team",
        errorElement: <Error />,
        element: <Team />,
      },
      {
        path: "/snapshots",
        errorElement: <Error />,
        element: <Snapshots />,
      },
      {
        path: "/transport/inbound/:departureId/:arrivalId",
        element: <InboundDetail />,
      },
      {
        path: "/transport/inbound/:departureId/:arrivalId/:category",
        element: <InboundDetail />,
      },
      {
        path: "/transport/outbound/:departureId",
        element: <OutboundDetail />,
      },
      {
        path: "/transport/outbound/:departureId/:arrivalName",
        element: <OutboundDetail />,
      },
      {
        path: "/transport/inbound",
        element: <InboundTransport />,
      },
      {
        path: "/transport/outbound",
        element: <OutboundTransport />,
      },
      {
        path: "/admin",
        errorElement: <Error />,
        element: <Admin />,
        children: [
          {
            path: "/admin",
            element: <UserAdmin />,
          },
          {
            path: "/admin/users",
            element: <UserAdmin />,
          },
          {
            path: "/admin/users/:userId",
            element: <User />,
          },
          {
            path: "/admin/companies",
            element: <CompanyAdmin />,
          },
          {
            path: "/admin/companies/new",
            element: <NewCompany />,
          },
          {
            path: "/admin/companies/:companyId",
            element: <Company />,
          },
        ],
      },
      {
        path: "/dashboard",
        errorElement: <Error />,
        element: <DashboardLayout />,
        children: [
          {
            path: "/dashboard/demo/:dashboardType?",
            element: <DemoDashboard />,
          },
          {
            path: "/dashboard/corporate/:dashboardType?",
            element: <CorporateDashboard />,
          },
          {
            path: "/dashboard/transport/:dashboardType?",
            element: <TransportDashboard />,
          },
          {
            path: "/dashboard/materials/:dashboardType?",
            element: <MaterialDashboard />,
          },
          {
            path: "/dashboard/packaging/:dashboardType?",
            element: <PackagingDashboard />,
          },
          {
            path: "/dashboard/facility/:dashboardType?",
            element: <FacilityDashboard />,
          },
          {
            path: "/dashboard/products/:dashboardType?",
            element: <ProductDashboard />,
          },
          {
            path: "/dashboard/customer/:dashboardType?",
            element: <CustomerDashboard />,
          },
          {
            path: "/dashboard/employee/:dashboardType?",
            element: <EmployeeDashboard />,
          },
          {
            path: "/dashboard/ghg",
            element: <GhgDashboard />,
          },
        ],
      },
      {
        path: "/products/eol",
        element: <EolOverview />,
      },
      {
        path: "/products/usage",
        element: <UsageOverview />,
      },
      {
        path: "/employees/commute",
        element: <EmployeeCommute />,
      },
      {
        path: "/employees/business_travel",
        element: <BusinessTravel />,
      },
      {
        path: "/employees/travel_modes",
        element: <TravelModes />,
      },
      {
        path: "/employees/travel_modes/:travelModeId",
        element: <TravelModeDetail />,
      },
      { path: "/explore_features/", element: <PremiumExplore /> },
    ],
  },
  {
    path: "/share",
    element: <PublicRouteLayout />,
    errorElement: <NotFound />,
    children: [{ path: "facility/:publishedId", element: <PublishedFacility /> }],
  },
];

export const AppRouter = createBrowserRouter(routes);
